import React from "react"
import { Label } from "semantic-ui-react"
import Price from "components/Price/Price";
import shop from "shop/shop"

const LabelSale = ( { percent, price, currency = 'EUR', strike = true } ) => <Label size="tiny" color={"green"}>{percent}&nbsp;<span
  className={`f7 white-80 ${strike ? "strike" : ""}`}><Price currency={currency}>{price}</Price></span></Label>

export default LabelSale


// WEBPACK FOOTER //
// ./src/theme/arnoldsports/components/Product/LabelSale.js